'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTasks', ['$scope', 'LicenseScheduledTasks', function ($scope, LicenseScheduledTasks) {
        $scope.scheduledTasksLoading = true;
        $scope.resetLicense();

        LicenseScheduledTasks.get({ licenseID: $scope.licenseID }).then(function (license_scheduled_tasks) {
            $scope.license_scheduled_tasks = license_scheduled_tasks;
            $scope.scheduledTasksLoading = false;
        });

        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.licensing.license.scheduledtask.details',
                    params: [
                        {
                            name: 'scheduledTaskID',
                            field: 'id'
                        },
                        {
                            name: 'licenseCategoryID',
                            field: 'license_category_id'
                        }
                    ]
                }
            },
            {
                label: 'Status',
                field: 'currently_active',
                type: 'text'
            },
            {
                label: 'Frequency',
                field: 'frequency',
                type: 'text'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Last Updated On',
                field: 'modifiedon',
                type: 'date'
            }
        ]


    }])
    ;